import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const HelpCenterSettingsSupportWebsiteAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(/* webpackChunkName: "async-help-center-setting-support-website-app" */ './src/ui'),
	),
	getPreloadProps: () => {
		return {};
	},
});
